import type { DataAttributes } from '@/components/utils/TypeUtils';

/**
 * Prefixes given attributes with `data-`
 *
 * For example: `{foo: 'bar'}` => `{data-foo: 'bar'}`
 * @param attrs - The attributes to prefix.
 * @param componentName - The name of the component to prefix with.
 */
export const getPrefixedDataAttributes = (
  attrs?: DataAttributes,
  componentName?: string
): DataAttributes => {
  const result: DataAttributes = componentName ? { 'data-component-name': componentName } : {};

  if (attrs) {
    Object.keys(attrs).forEach((key) => {
      result[`data-test${key}`] = attrs[key];
      result[`data-${key}`] = attrs[key];
    });
  }

  return result;
};

const rHyphen = /-(.)/g;

/**
 * A method to convert a string to camelCase.
 *
 * @param {string} string - The string to convert.
 * @returns - A camelCased string.
 */
export const camelize = (string: string): string =>
  string.replace(rHyphen, (_, chr) => chr.toUpperCase());
